var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "uploadBlock" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.formUploadFieldes.isBeri.isShow,
              expression: "formUploadFieldes.isBeri.isShow"
            }
          ]
        },
        [
          _c("SegmentName", { staticClass: "segmentName--warning" }, [
            _vm._v(_vm._s(_vm.UploadText.is_beri))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table_block" }, [
            _c("table", [
              _c(
                "tbody",
                [
                  _c(
                    "TableTr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formUploadFieldes.beriTiming.isShow,
                          expression: "formUploadFieldes.beriTiming.isShow"
                        }
                      ]
                    },
                    [
                      _c(
                        "TableTh",
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formUploadFieldes.beriTiming.name) +
                              "\n              "
                          ),
                          _c("RequiredText", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.formUploadFieldes.beriTiming.required,
                                expression:
                                  "formUploadFieldes.beriTiming.required"
                              }
                            ]
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("InputRadio", {
                            attrs: {
                              name: _vm.formUploadFieldes.beriTiming.key,
                              choices: _vm.beriTimingOptionList,
                              inputRadioVal: _vm.form.beri_timing,
                              handleChange: function($event) {
                                return _vm.onChangeBeriTiming($event)
                              }
                            },
                            on: {
                              "update:inputRadioVal": function($event) {
                                return _vm.$set(_vm.form, "beri_timing", $event)
                              },
                              "update:input-radio-val": function($event) {
                                return _vm.$set(_vm.form, "beri_timing", $event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.form.beri_timing === "審査後すぐ"
                            ? _c("p", { staticClass: "notice" }, [
                                _vm._v(_vm._s(_vm.note.beri_timing_soon))
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableTr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formUploadFieldes.beriAt.isShow,
                          expression: "formUploadFieldes.beriAt.isShow"
                        }
                      ]
                    },
                    [
                      _c(
                        "TableTh",
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formUploadFieldes.beriAt.name) +
                              "\n              "
                          ),
                          _c("RequiredText", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.formUploadFieldes.beriAt.required,
                                expression: "formUploadFieldes.beriAt.required"
                              }
                            ]
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "div",
                            [
                              _c("el-date-picker", {
                                staticClass: "u-w--200",
                                attrs: {
                                  type: "date",
                                  placeholder:
                                    _vm.formUploadFieldes.beriAt.placeholder,
                                  format: "yyyy/M/d",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  id: _vm.formUploadFieldes.beriAt.key,
                                  name: _vm.formUploadFieldes.beriAt.key,
                                  disabled: !_vm.formUploadFieldes.beriAt
                                    .required
                                },
                                on: { change: _vm.onChangeBeriDate },
                                model: {
                                  value: _vm.form.beri_at,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "beri_at", $$v)
                                  },
                                  expression: "form.beri_at"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  staticClass: "u-w--200",
                                  attrs: {
                                    placeholder:
                                      _vm.formUploadFieldes.beriAt.placeholder,
                                    disabled: !_vm.formUploadFieldes.beriAt
                                      .required
                                  },
                                  on: { change: _vm.onChangeBeriTime },
                                  model: {
                                    value: _vm.beriTime,
                                    callback: function($$v) {
                                      _vm.beriTime = $$v
                                    },
                                    expression: "beriTime"
                                  }
                                },
                                _vm._l(_vm.beriTimeOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "notice u-mt--10",
                            domProps: {
                              innerHTML: _vm._s(_vm.note.beri_timing_specify)
                            }
                          }),
                          _vm._v(" "),
                          _c("ErrorMessage", {
                            staticClass: "error-beri_at-required_if"
                          }),
                          _vm._v(" "),
                          _c("ErrorMessage", {
                            staticClass: "error-beri_at-date"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("SegmentName", [_vm._v(_vm._s(_vm.UploadText.direct_debit))]),
      _vm._v(" "),
      _c("div", { staticClass: "table_block" }, [
        _c("table", [
          _c(
            "tbody",
            [
              _c(
                "TableTr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.formUploadFieldes.bankAccountHolder.isShow,
                      expression: "formUploadFieldes.bankAccountHolder.isShow"
                    }
                  ]
                },
                [
                  _c(
                    "TableTh",
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formUploadFieldes.bankAccountHolder.name) +
                          "\n            "
                      ),
                      _c("RequiredText", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.formUploadFieldes.bankAccountHolder.required,
                            expression:
                              "formUploadFieldes.bankAccountHolder.required"
                          }
                        ]
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("InputRadio", {
                        attrs: {
                          name: _vm.formUploadFieldes.bankAccountHolder.key,
                          choices:
                            _vm.formUploadFieldes.bankAccountHolder.choices,
                          inputRadioVal: _vm.form.bank_account_holder,
                          handleChange: function($event) {
                            return _vm.onChangeBankAccountHolder($event)
                          }
                        },
                        on: {
                          "update:inputRadioVal": function($event) {
                            return _vm.$set(
                              _vm.form,
                              "bank_account_holder",
                              $event
                            )
                          },
                          "update:input-radio-val": function($event) {
                            return _vm.$set(
                              _vm.form,
                              "bank_account_holder",
                              $event
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("ErrorMessage", {
                        staticClass: "error-bank_account_holder-required"
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableTr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.formUploadFieldes.bankAccountHolderName.isShow,
                      expression:
                        "formUploadFieldes.bankAccountHolderName.isShow"
                    }
                  ]
                },
                [
                  _c(
                    "TableTh",
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.formUploadFieldes.bankAccountHolderName.name
                          ) +
                          "\n            "
                      ),
                      _c("RequiredText", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.formUploadFieldes.bankAccountHolderName
                                .required,
                            expression:
                              "formUploadFieldes.bankAccountHolderName.required"
                          }
                        ]
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("el-input", {
                        staticClass: "u-w--200",
                        attrs: {
                          placeholder: "",
                          name: _vm.formUploadFieldes.bankAccountHolderName.key
                        },
                        model: {
                          value: _vm.form.bank_account_holder_name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "bank_account_holder_name", $$v)
                          },
                          expression: "form.bank_account_holder_name"
                        }
                      }),
                      _vm._v(" "),
                      _c("ErrorMessage", {
                        staticClass: "error-bank_account_holder_name-required"
                      }),
                      _vm._v(" "),
                      _c("ErrorMessage", {
                        staticClass: "error-bank_account_holder_name-string"
                      }),
                      _vm._v(" "),
                      _c("ErrorMessage", {
                        staticClass:
                          "error-bank_account_holder_name-kana_with_space"
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableTr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.formUploadFieldes.bankAccountRegistration.isShow,
                      expression:
                        "formUploadFieldes.bankAccountRegistration.isShow"
                    }
                  ]
                },
                [
                  _c(
                    "TableTh",
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.formUploadFieldes.bankAccountRegistration.name
                          ) +
                          "\n            "
                      ),
                      _c("RequiredText", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.formUploadFieldes.bankAccountRegistration
                                .required,
                            expression:
                              "formUploadFieldes.bankAccountRegistration.required"
                          }
                        ]
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("ul", { staticClass: "bank-account__reg_list" }, [
                        _c("li", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-radio",
                                {
                                  key: "",
                                  attrs: { label: "A" },
                                  on: {
                                    change: _vm.onChangeBankAccountRegistrationA
                                  },
                                  model: {
                                    value: _vm.bank_account_registration_a,
                                    callback: function($$v) {
                                      _vm.bank_account_registration_a = $$v
                                    },
                                    expression: "bank_account_registration_a"
                                  }
                                },
                                [
                                  _vm._v(
                                    "端末キャッシュカード登録(Anywhere Next)"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.bank_account_registration_a === "A" ||
                          _vm.form.bank_account_registration === "A済" ||
                          _vm.form.bank_account_registration === "A予定"
                            ? _c(
                                "div",
                                [
                                  _c("ul", [
                                    _c(
                                      "li",
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            key: "",
                                            attrs: {
                                              label: "A予定",
                                              name: "bank_account_registration"
                                            },
                                            on: {
                                              change:
                                                _vm.onChangeBankAccountRegistration
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .bank_account_registration,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "bank_account_registration",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.bank_account_registration"
                                            }
                                          },
                                          [_vm._v("登録予定(A予定)")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            key: "",
                                            attrs: {
                                              label: "A済",
                                              name: "bank_account_registration"
                                            },
                                            on: {
                                              change:
                                                _vm.onChangeBankAccountRegistration
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .bank_account_registration,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "bank_account_registration",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.bank_account_registration"
                                            }
                                          },
                                          [_vm._v("登録済(A済)")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _vm.formUploadFieldes
                                              .bankAccountRegistrationDate
                                              .isShow
                                              ? _c("el-date-picker", {
                                                  staticClass: "u-w--200",
                                                  attrs: {
                                                    type: "date",
                                                    placeholder:
                                                      _vm.formUploadFieldes
                                                        .bankAccountRegistrationDate
                                                        .placeholder,
                                                    format: "yyyy/M/d",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    id:
                                                      _vm.formUploadFieldes
                                                        .bankAccountRegistrationDate
                                                        .key,
                                                    disabled: !_vm
                                                      .formUploadFieldes
                                                      .bankAccountRegistrationDate
                                                      .required
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form
                                                        .bank_account_registration_date,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "bank_account_registration_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.bank_account_registration_date"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.formUploadFieldes
                                              .bankAccountRegistrationDate
                                              .isShow
                                              ? _c(
                                                  "p",
                                                  { staticClass: "notice" },
                                                  [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.note
                                                            .bank_account_registration_date
                                                        ) +
                                                        "\n                          "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.form
                                              .bank_account_registration_date ===
                                            ""
                                              ? _c("ErrorMessage", {
                                                  staticClass:
                                                    "error-bank_account_registration_date-required_if"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("ErrorMessage", {
                                              staticClass:
                                                "error-bank_account_registration_date-date"
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.isInputBankAccountRegistration
                                    ? _c("ErrorMessage", [
                                        _vm._v("どちらか必ず選択してください。")
                                      ])
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.getOption.use_aplus === true
                          ? _c("li", [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      key: "",
                                      attrs: {
                                        label: "Web登録予定",
                                        name: "bank_account_registration"
                                      },
                                      on: {
                                        change:
                                          _vm.onChangeBankAccountRegistration
                                      },
                                      model: {
                                        value:
                                          _vm.form.bank_account_registration,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "bank_account_registration",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.bank_account_registration"
                                      }
                                    },
                                    [_vm._v("Web登録予定")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "notice" }, [
                                _vm._v(
                                  "※申込送信後に、お客様マイページよりご登録ください。"
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "notice" }, [
                                _vm._v(
                                  "マイページはSMSで届くURLよりログインいただくか、当社ホームページ掲載のQRコードを読み取ることでもログイン可能です。"
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "notice" }, [
                                _vm._v(
                                  "※SMS認証で、認証コードが届かなかったお客様はご利用できません。"
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-radio",
                                {
                                  key: "",
                                  attrs: {
                                    label: "口座振替依頼書",
                                    name: "bank_account_registration"
                                  },
                                  on: {
                                    change: _vm.onChangeBankAccountRegistration
                                  },
                                  model: {
                                    value: _vm.form.bank_account_registration,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "bank_account_registration",
                                        $$v
                                      )
                                    },
                                    expression: "form.bank_account_registration"
                                  }
                                },
                                [_vm._v("口座振替依頼書（郵送）")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "notice" }, [
                            _vm._v(
                              "※口座振替依頼書はTopページ「各種書類」より印刷いただきご利用ください。（白黒可）"
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isInputBankAccountRegistration
                        ? _c(
                            "ErrorMessage",
                            {
                              staticClass:
                                "error-bank_account_registration-required"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.BankAccountRegistrationErrorMessage)
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("SegmentName", [_vm._v(_vm._s(_vm.UploadText.identification))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table_block", attrs: { id: "identification_field" } },
        [
          _c(
            "div",
            { staticClass: "clearfix camera" },
            [
              _vm._l(_vm.form.identification, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "camera__item float-left" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "camera__item--inner modal__img",
                        class: { delete: item.delete },
                        on: {
                          click: function($event) {
                            item.see = true
                          }
                        }
                      },
                      [
                        _c("img", { attrs: { src: item.image, alt: "" } }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-zoom-in" })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "Upload Image",
                          visible: item.see,
                          width: "80%"
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(item, "see", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "uploadImageWrapper" }, [
                          _c("img", {
                            attrs: { src: item.image, alt: "", width: "100%" }
                          }),
                          _vm._v(" "),
                          item.can_delete
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { "margin-top": "15px" }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger" },
                                      on: {
                                        click: function($event) {
                                          item.see = false
                                          _vm.imageDelete(
                                            "identification",
                                            item.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete"
                                      }),
                                      _vm._v(" 画像を削除する\n              ")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "camera__item camera__item--add float-left",
                  on: {
                    click: function($event) {
                      return _vm.activeCamera("identification")
                    }
                  }
                },
                [_vm._m(0)]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("p", { staticClass: "notice" }, [
            _vm._v(_vm._s(_vm.note.identification[0]))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "notice" }, [
            _vm._v(_vm._s(_vm.note.identification[1]))
          ]),
          _vm._v(" "),
          _c("ErrorMessage", { staticClass: "error-identification-required" }),
          _vm._v(" "),
          _c("ErrorMessage", { staticClass: "error-identification-array" }),
          _vm._v(" "),
          _vm._l(_vm.form.identification, function(item, index) {
            return _c("ErrorMessage", {
              key: index,
              class: ["error-identification." + index + ".id-exists"]
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("SegmentName", [_vm._v(_vm._s(_vm.UploadText.contract_documents))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "table_block",
          attrs: { id: "contract_documents_field" }
        },
        [
          _c(
            "div",
            { staticClass: "clearfix camera" },
            [
              _vm._l(_vm.form.contract_documents, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "camera__item float-left" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "camera__item--inner modal__img",
                        class: { delete: item.delete },
                        on: {
                          click: function($event) {
                            item.see = true
                          }
                        }
                      },
                      [
                        _c("img", { attrs: { src: item.image, alt: "" } }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-zoom-in" })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "Upload Image",
                          visible: item.see,
                          width: "80%"
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(item, "see", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "uploadImageWrapper" }, [
                          _c("img", {
                            attrs: { src: item.image, alt: "", width: "100%" }
                          }),
                          _vm._v(" "),
                          item.can_delete
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { "margin-top": "15px" }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger" },
                                      on: {
                                        click: function($event) {
                                          item.see = false
                                          _vm.imageDelete(
                                            "contract_documents",
                                            item.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete"
                                      }),
                                      _vm._v(" 画像を削除する\n              ")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "camera__item camera__item--add float-left",
                  on: {
                    click: function($event) {
                      return _vm.activeCamera("contract_documents")
                    }
                  }
                },
                [_vm._m(1)]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("p", { staticClass: "notice" }, [
            _vm._v(_vm._s(_vm.note.contract_documents))
          ]),
          _vm._v(" "),
          _c("ErrorMessage", {
            staticClass: "error-contract_documents-required"
          }),
          _vm._v(" "),
          _c("ErrorMessage", { staticClass: "error-contract_documents-array" }),
          _vm._v(" "),
          _vm._l(_vm.form.contract_documents, function(item, index) {
            return _c("ErrorMessage", {
              key: index,
              class: ["error-contract_documents." + index + ".id-exists"]
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "SegmentName",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.getHasMinors,
              expression: "getHasMinors"
            }
          ]
        },
        [_vm._v(_vm._s(_vm.UploadText.parental_consent))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.getHasMinors,
              expression: "getHasMinors"
            }
          ],
          staticClass: "table_block",
          attrs: { id: "parental_consent_field" }
        },
        [
          _c(
            "div",
            { staticClass: "clearfix camera" },
            [
              _vm._l(_vm.form.parental_consent, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "camera__item float-left" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "camera__item--inner modal__img",
                        class: { delete: item.delete },
                        on: {
                          click: function($event) {
                            item.see = true
                          }
                        }
                      },
                      [
                        _c("img", { attrs: { src: item.image, alt: "" } }),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-zoom-in" })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "Upload Image",
                          visible: item.see,
                          width: "80%"
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(item, "see", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "uploadImageWrapper" }, [
                          _c("img", {
                            attrs: { src: item.image, alt: "", width: "100%" }
                          }),
                          _vm._v(" "),
                          item.can_delete
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { "margin-top": "15px" }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger" },
                                      on: {
                                        click: function($event) {
                                          item.see = false
                                          _vm.imageDelete(
                                            "parental_consent",
                                            item.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete"
                                      }),
                                      _vm._v(" 画像を削除する\n              ")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "camera__item camera__item--add float-left",
                  on: {
                    click: function($event) {
                      return _vm.activeCamera("parental_consent")
                    }
                  }
                },
                [_vm._m(2)]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("p", { staticClass: "notice" }, [
            _vm._v(_vm._s(_vm.note.parental_consent))
          ]),
          _vm._v(" "),
          _c("ErrorMessage", {
            staticClass: "error-parental_consent-required"
          }),
          _vm._v(" "),
          _c("ErrorMessage", { staticClass: "error-parental_consent-array" }),
          _vm._v(" "),
          _vm._l(_vm.form.parental_consent, function(item, index) {
            return _c("ErrorMessage", {
              key: index,
              class: ["error-parental_consent." + index + ".id-exists"]
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: {
          type: "file",
          name: "upfile",
          id: "identification",
          accept: "image/*",
          capture: "camera"
        },
        on: { change: _vm.uploadImage }
      }),
      _vm._v(" "),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: {
          type: "file",
          name: "upfile",
          id: "contract_documents",
          accept: "image/*",
          capture: "camera"
        },
        on: { change: _vm.uploadImage }
      }),
      _vm._v(" "),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: {
          type: "file",
          name: "upfile",
          id: "parental_consent",
          accept: "image/*",
          capture: "camera"
        },
        on: { change: _vm.uploadImage }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "next" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-arrow-left" },
              on: { click: _vm.backPage }
            },
            [_vm._v("前へ戻る")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-arrow-right" },
              on: { click: _vm.nextPage }
            },
            [_vm._v("決定")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "el-receiptDialog",
          attrs: {
            title: "受領方法の選択",
            visible: _vm.checkUser,
            width: "80%"
          },
          on: {
            "update:visible": function($event) {
              _vm.checkUser = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c("p", { staticClass: "el-receiptDialog__mainTitle" }, [
                _vm._v("お申し込み控えの受領方法をどちらか選択してください。")
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "el-receiptDialog__strongBtn",
                          attrs: {
                            type: "primary",
                            disabled: _vm.form.is_beri
                          },
                          on: {
                            click: function($event) {
                              return _vm.throwNextPage("qr")
                            }
                          }
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "el-receiptDialog__btnText" },
                            [
                              _vm._v(
                                "電磁的方法（PDFファイル）による受領（保存）に同意します。"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "el-receiptDialog__btnStrongText" },
                            [_vm._v("申込を送信する")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "el-receiptDialog__btnText" },
                            [_vm._v("QRコード表示画面へ")]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "el-receiptDialog__strongBtn",
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.throwNextPage("paper")
                            }
                          }
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "el-receiptDialog__btnText" },
                            [_vm._v("書面による受領を希望します。")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "el-receiptDialog__btnStrongText" },
                            [_vm._v("申込を送信する")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "el-receiptDialog__btnText" },
                            [_vm._v("お客様控え発行へ")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.checkUser = false
                    }
                  }
                },
                [_vm._v("戻る")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "camera__item--inner" }, [
      _c("i", { staticClass: "el-icon-camera camera__icon" }),
      _vm._v(" "),
      _c("p", { staticClass: "camera__txt" }, [_vm._v("写真を追加する")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "camera__item--inner" }, [
      _c("i", { staticClass: "el-icon-camera camera__icon" }),
      _vm._v(" "),
      _c("p", { staticClass: "camera__txt" }, [_vm._v("写真を追加する")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "camera__item--inner" }, [
      _c("i", { staticClass: "el-icon-camera camera__icon" }),
      _vm._v(" "),
      _c("p", { staticClass: "camera__txt" }, [_vm._v("写真を追加する")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }